import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { storeObj, getObj } from '../global';
import { AzureClient } from './azure-client.service';
import { User } from '../models/user';
import { RelatedUser } from '../models/related-user';

@Injectable()
export class IdentityService {

    static ROLE_Administrator: string = 'Portal Administrator SG';
    static ROLE_Marketing: string = 'Marketing SG';
    static ROLE_MarketingManager: string = 'Marketing Management SG';
    static ROLE_Executive: string = 'Executive';
    static ROLE_SalesManager: string = 'Sales Managers';
    static ROLE_AreaManager: string = 'Area Managers SG';
    static ROLE_AccountManager: string = 'All Account Managers'
    static ROLE_ProductManagement: string = 'Product Management';
    static ROLE_CustomerRelations: string = 'Customer Relations';
    static ROLE_OrderServices: string = 'Order Services SG';
    static ROLE_FactoryRep: string = 'Factory Reps SG';
    private _me: User;

    _me$: Subject<User> = <Subject<User>>new Subject();
    get me$() { return this._me$.asObservable(); }
    constructor(private azure: AzureClient) { }

    public get me(): User {
        return getObj('me');
    }

    public loadMe() {

        var table: any = this.azure.client.getTable('WhoAmI');
        var parameters = '$expand=apps, users, roles, managedTerritories, address';
        table.read(parameters)
            .then((results: User) => {
                storeObj('me', results[0]);
                this._me$.next(results[0]);
            },
                (error) => {
                    console.error(error);
                });
    }

    // Common code : Use to query for created user when the table supports it
    public rawCriteriaforUser(userId: string = this.me.id): string {
        return `CreatedBy/User_Id eq '${userId}'`;
    }

    public expandForUser(): string {
        return "CreatedBy";
    }

    public hasRole(roleName: string): boolean {
        if (!this.me || !this.me.roles)
            return false;
        else
            return this.me.roles.findIndex((r) => { return r.name === roleName; }) >= 0 ? true : false;
    }

    public hasAnyRoles(roleNames: string[]): boolean {
        for (var rolename of roleNames) {
            if (this.hasRole(rolename))
                return true;
        }

        return false;
    }

    public hasAllRoles(roleNames: string[]): boolean {
        if (!roleNames || roleNames.length == 0)
            return false;

        for (var rolename in roleNames) {
            if (!this.hasRole(rolename))
                return false;
        }

        return true;
    }

    public isAdministratorRole(): boolean {
        return this.hasRole(IdentityService.ROLE_Administrator);
    }

    public isOrderServicesRole(): boolean {
        return this.hasRole(IdentityService.ROLE_OrderServices);
    }

    public isExecutiveRole(): boolean {
        return this.hasRole(IdentityService.ROLE_Executive);
    }

    public isAccountManagerRole(): boolean {
        return this.hasRole(IdentityService.ROLE_AccountManager)
            && !this.hasRole(IdentityService.ROLE_SalesManager);
    }

    public isFactoryRepRole(): boolean {
        return this.hasRole(IdentityService.ROLE_FactoryRep);
    }

    public isSalesManagerRole(): boolean {
        return this.hasRole(IdentityService.ROLE_SalesManager);
    }

    public isAreaManagerRole(): boolean {
        return this.hasRole(IdentityService.ROLE_AreaManager);
    }

    public isMarketingRole(): boolean {
        return this.hasRole(IdentityService.ROLE_Marketing);
    }

    public isMarketingManagerRole(): boolean {
        return this.hasRole(IdentityService.ROLE_MarketingManager);
    }

    public isProductManagementRole(): boolean {
        return this.hasRole(IdentityService.ROLE_ProductManagement);
    }

    public createdByMe(): RelatedUser {
        let createdBy = new RelatedUser(this.me);
        return createdBy;
    }

    public getAreaMgrForAccountMgr(amId:string): string
    {
        let cmp = amId.toLowerCase();
        // Could be modeled in the db if changing often, or if needed elsewhere
        if(cmp ==='d30ef609-22b2-4105-8564-921ca5a923ee' ||        // Dufault
            cmp === '444354e3-057c-4000-b18c-52e754f65e14' ||      // Levesque
            cmp === '724f7c89-3079-488b-88cb-3f270661e465')        // Mendels
            return 'b0198aac-248b-492a-9f32-58b34eee9411';         // Guinane
        else if (cmp === '147826cc-c9cf-4537-b470-16ca6bbaca90' || // Jewell
            cmp === '24eab4c8-9299-4a26-8644-7c628161d9e1' ||      // Goodman
            cmp === '98594cdb-88e9-4cbc-8dd1-a917da31ff94' ||      // Raine
            cmp === '4ad2d4d1-719a-432c-bb61-4f2b71dafaec')        // Lemons
            return '6ed6fce9-1c49-497e-8d27-1d5e20c68204';         // Chet
        else if (cmp === '79671c1d-9c4d-4694-93cf-dd17aac0a80d' || // Coble
            cmp === 'cf5aa576-431b-4822-bd00-058050e1cb0f' ||      // Smith, L
            cmp === 'c3b930be-a09c-489d-90f0-fe90cd5cad41' ||      // Moore
            cmp === '22a74835-46e5-4ddc-9f76-2371534ef1b3')        // Brown
            return '8ae827d5-581f-479f-80ba-50c4a9948712';         // Elledge
        else
            return '';
    }
}